export function initCbreSelectMultiple() {
    // Iterate over each select element
    $("select.cbreselectmultiple").each(function() {
        if ($(this).hasClass("d-none")) return;
        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children("option").length;

        // Hides the select element
        $this.addClass("d-none");

        // Wrap the select element in a div
        var wrap = $this.wrap('<div class="cbreSelect-wrap"></div>');
        var selectWrap = wrap.closest(".cbreSelect-wrap");

        // Insert a styled div to sit over the top of the hidden select element
        $this.after(
            '<div class="cbreSelect-element-container"><div class="cbreSelect-element"></div></div>'
        );

        // Cache the styled div
        var $cbreSelectElementContainer = $this
            .parent()
            .find(".cbreSelect-element-container");
        var $cbreSelectElement = $this.parent().find(".cbreSelect-element");

        // Show the first select option in the styled div
        var $selectedOpt = $this.children(":selected");
        if ($selectedOpt.length > 0) var text = $selectedOpt.text();
        else var text = $this.attr("placeholder");
        $cbreSelectElement.text(text);

        // Insert an unordered list after the styled div and also cache the list
        var listContainer = $(
            '<div class="cbreSelect-options-container"></div>'
        ).insertAfter($cbreSelectElementContainer);

        var $list = $("<ul />", {
            class: "cbreSelect-options"
        }).appendTo(listContainer);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            $("<li />", {
                text: $this
                    .children("option")
                    .eq(i)
                    .text(),
                rel: $this
                    .children("option")
                    .eq(i)
                    .val(),
                class: $this
                    .children("option")
                    .eq(i)
                    .is(":selected")
                    ? "selected"
                    : ""
            }).appendTo($list);
        }

        // Cache the list items
        var $listItems = $list.children("li");

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $cbreSelectElementContainer.on("click", function(e) {
            // e.stopPropagation();
            var $selected = $(this).find("> .cbreSelect-element");
            $(".cbreSelect-wrap.active").each(function() {
                if ($selected.is(selectWrap)) return;
                $($selected).removeClass("active");
            });
            selectWrap.toggleClass("active");
        });

        //Create a

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        $listItems.on("click", function(e) {
            e.stopPropagation();

            // $list.children("li").removeClass("selected");
            let $selectVal = $this.val();
            let $newVal = $(this).attr("rel");

            if ($newVal.length == 0) return;

            // Validate if the value is already in the array, if it is, remove it, if it's not, add it
            let valIndex = $selectVal.indexOf($newVal);
            if (valIndex !== -1) {
                $selectVal.splice(valIndex, 1);
            } else {
                $selectVal.push($newVal);
            }

            // Set the new value to the select element depending on the length of the array
            if ($selectVal.length == 0) {
                $cbreSelectElement.text($this.attr("placeholder"));
            } else {
                if ($selectVal.length == 1) {
                    $cbreSelectElement.text(
                        $this
                            .children("option")
                            .eq(
                                $this
                                    .find(
                                        "option[value='" + $selectVal[0] + "']"
                                    )
                                    .index()
                            )
                            .text()
                    );
                } else {
                    //
                    $cbreSelectElement.text(
                        $selectVal.length + " " + $this.attr("label")
                    );
                }
            }

            $this.val($selectVal).trigger("change");
            // console.log($this.val());
            $(this).toggleClass("selected");
            // selectWrap.toggleClass("active");
            // $list.hide();
            /* alert($this.val()); Uncomment this for demonstration! */
        });

        // Hides the unordered list when clicking outside of it
        $(document).on("click", function(e) {
            if (
                $(e.target).is(
                    ".cbreSelect-wrap.active, .cbreSelect-wrap.active *"
                )
            )
                return;
            selectWrap.removeClass("active");
            // $list.hide();
        });
    });
}
